import { ClipboardIcon } from '@heroicons/react/24/solid'
import Image from 'next/image'
import { useRouter } from 'next/router'
import { FC, ReactNode, useCallback } from 'react'

import { cn } from '@/app/utils'
import { AppButton } from '@/components/shared/button'

type Props = {
  icon?: FC
  image?: ReactNode
  title?: ReactNode
  description?: ReactNode
  areFiltersApplied?: boolean
  withGoToMainButton?: boolean
  className?: string
  titleClassName?: string
  descriptionClassName?: string
  buttonClassName?: string
  onButtonClick?: () => void
  buttonName?: string
  buttonComponent?: ReactNode
}

const EmptyListPlug: FC<Props> = ({
  icon,
  image,
  title,
  description,
  areFiltersApplied,
  withGoToMainButton,
  className,
  titleClassName,
  descriptionClassName,
  buttonClassName,
  onButtonClick,
  buttonName,
  buttonComponent
}) => {
  const router = useRouter()

  const Icon = icon || ClipboardIcon

  const handleButtonClick = useCallback(() => {
    if (onButtonClick) {
      onButtonClick()
    } else {
      router.push('/')
    }
  }, [onButtonClick, router])

  return (
    <div className={cn('mt-80 flex flex-col items-center xs:mt-36', className)}>
      {image || (
        <div
          className={cn(
            'flex h-[124px] w-[124px] items-center justify-center lg:h-100 lg:w-100',
            !areFiltersApplied && 'rounded-full border border-grey-10 bg-white'
          )}
        >
          {areFiltersApplied ? (
            <Image
              src="/images/balance/MagnifyingGlass.png"
              width={100}
              height={100}
              alt="image"
              className="rotate-12"
            />
          ) : (
            <Icon
              className={cn(
                !areFiltersApplied && 'h-48 w-48 text-grey-20 lg:h-36 lg:w-36'
              )}
            />
          )}
        </div>
      )}

      <h3
        className={cn(
          'mt-32 text-center font-bold text-24 lg:mt-20 xxs:text-16',
          titleClassName
        )}
      >
        {areFiltersApplied && !title ? 'Ничего не нашлось' : title}
      </h3>
      {areFiltersApplied && !description && (
        <p className="mt-8 text-center text-grey-60 text-16 xxs:text-12">
          Попробуйте изменить параметры поиска или сбросить фильтры
        </p>
      )}
      {description && (
        <p
          className={cn(
            'mt-8 text-center text-16 xxs:text-12',
            'text-grey-60',
            descriptionClassName
          )}
        >
          {description}
        </p>
      )}
      {withGoToMainButton && (
        <AppButton
          variant="secondary"
          size="large"
          className={cn(
            'mt-32 w-[188px] lg:!h-[48px] lg:w-[128px]',
            buttonClassName
          )}
          onClick={handleButtonClick}
        >
          {buttonName ?? 'На главную'}
        </AppButton>
      )}
      {buttonComponent && <div className="mt-32">{buttonComponent}</div>}
    </div>
  )
}

export default EmptyListPlug
